module.exports = __webpack_public_path__ + "img/banner2.b0159b90.png";